import { Component } from 'preact'
import { SVG, Loading } from '.'

export default class CollapsableBox extends Component {
  constructor(props) {
    super()

    this.state = { opened: props.opened || false }
    this.toggle = this.toggle.bind(this)
  }

  toggle() {
    let { opened } = this.state
    opened = !opened

    this.setState({ opened }, () => {
      if (!opened) return
      if (this.DOMNode && this.DOMNode.scrollIntoViewIfNeeded) this.DOMNode.scrollIntoViewIfNeeded()
    })

    if (this.props.onToggle) {
      this.props.onToggle(opened)
    }
  }

  render() {
    let { label, getContent } = this.props
    let { opened } = this.state

    let box = (
      <div
        class={Missive.classNames({
          'box': true,
          'box-collapsable': true,
          'box-collapsable--opened': opened,
        })}
      >
        <div onClick={this.toggle} class="box-header columns-middle">
          <span class="margin-right-small">
            <SVG name="menu-right" width={6} height={10} />
          </span>
          <span class="column-grow ellipsis">{label}</span>
          {this.props.refreshing && (
            <span>
              <Loading size={14} />
            </span>
          )}
        </div>
        {opened || this.props.alwaysRenderContent ? (
          <div class="box-content">{getContent && getContent()}</div>
        ) : null}
      </div>
    )

    if (this.props.noAutoScroll) {
      return box
    }

    return (
      <div
        class="row"
        ref={(DOMNode) => {
          this.DOMNode = DOMNode
        }}
      >
        {box}
      </div>
    )
  }
}
